import { render, staticRenderFns } from "./duel.vue?vue&type=template&id=a65e885a"
import script from "./duel.vue?vue&type=script&lang=js"
export * from "./duel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports